import { DefaultModelProperty, LabelValue } from '../standard'
import CuratedSeriesList from './curated-series-list-model'
import curatedSeriesListProperties from './curatedSeriesList-properties'
import { CuratedSeriesListProperties } from './curatedSeriesList-property-definitions'

export async function OnEvents(
  eventType: string,
  form: CuratedSeriesList,
  property: CuratedSeriesListProperties,
): Promise<CuratedSeriesList> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(property: CuratedSeriesListProperties): boolean {
  switch (property) {
    default:
      return false
  }
}

export function IsVisible(property: CuratedSeriesListProperties): boolean {
  switch (property) {
    case CuratedSeriesListProperties.Series:
      return false
    case CuratedSeriesListProperties.ReleaseZones:
      return false
    case CuratedSeriesListProperties.Owner:
      return false
    case CuratedSeriesListProperties.Id:
      return false
    case CuratedSeriesListProperties.Created:
      return false
    case CuratedSeriesListProperties.Updated:
      return false
    case CuratedSeriesListProperties.Deleted:
      return false
    case CuratedSeriesListProperties.Version:
      return false
    case 'processedSeries':
      return false
    default:
      return true
  }
}
async function change(
  property: CuratedSeriesListProperties,
  value: CuratedSeriesList,
): Promise<CuratedSeriesList> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<CuratedSeriesListProperties>[] {
  return curatedSeriesListProperties as DefaultModelProperty<CuratedSeriesListProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<CuratedSeriesListProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<CuratedSeriesListProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<CuratedSeriesListProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(
  property: CuratedSeriesListProperties,
): LabelValue<any>[] {
  switch (property) {
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: CuratedSeriesListProperties): boolean {
  switch (property) {
    case CuratedSeriesListProperties.Owner:
      return false
    case CuratedSeriesListProperties.Id:
      return false
    case CuratedSeriesListProperties.Created:
      return false
    case CuratedSeriesListProperties.Updated:
      return false
    case CuratedSeriesListProperties.Deleted:
      return false
    case CuratedSeriesListProperties.Version:
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<CuratedSeriesListProperties>[],
): DefaultModelProperty<CuratedSeriesListProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<CuratedSeriesListProperties>) => {
      switch (modelProperty.name) {
        default:
          break
      }
      return modelProperty
    },
  )
}
